export const formatSpecImg = (productDetail: any) => {
    if (!productDetail) {
        return '';
    }
    const imgObj = JSON.parse(typeof productDetail?.images === 'string' ? productDetail?.images : JSON.stringify(productDetail?.images) || '{}');
    const skuLen = productDetail?.skuList?.length || 0;
    return (
        imgObj?.spaceImages ||
        imgObj?.transparentImages ||
        imgObj?.images ||
        (skuLen > 1 ? productDetail.skuList[0].images : productDetail?.images?.spaceImages)
    );
};
